module.exports = __webpack_public_path__ + "img/bg-strip.e1a32ec8.svg";